module.exports = __webpack_public_path__ + "img/視聽室.b2f36bca.jpg";